import useFlotte from "../../hooks/useFlotte";
import Cells from "./Cells/Cells";
import { columnsConfig } from "./flotteColumns.config";
import styles from "../FlotteTable/FlotteTable.module.scss";
import { useAtom } from "jotai";
import { connectedUserAtom } from "../../../../../middlewares/AuthMiddleware";
import { isVORole } from "./FlotteUtils";

const FlotteLigneVO = ({ item }) => {
  const [connectedUser] = useAtom(connectedUserAtom);
  const voColumns = Object.keys(columnsConfig).filter(
    (col) => columnsConfig[col].category === "VO",
  );

  const { actions } = useFlotte();

  return (
    <div style={{ position: "relative" }}>
      <div className={`${styles.tableContainerSimulator} `}>
        <table className="table bg-default">
          <thead className="table-light">
            <tr>
              {voColumns.map((col) => (
                <th
                  key={col}
                  style={{
                    minWidth: 120,
                  }}
                >
                  {/* {!isVORole(connectedUser?.role) && (
                    <>
                      {columnsConfig[col].visibleVO && (
                        <span
                          className="badge badge-info"
                          style={{
                            fontSize: "0.58rem",
                            fontWeight: "400",
                            padding: "2px 5px",
                            verticalAlign: "middle",
                          }}
                          title="Cette colonne est visible par les utilisateurs VO (51/61)"
                        >
                          51
                        </span>
                      )}
                      {columnsConfig[col].isVO531 &&
                        columnsConfig[col].visibleVO531 && (
                          <span
                            className="badge"
                            style={{
                              fontSize: "0.58rem",
                              fontWeight: "400",
                              padding: "2px 5px",
                              verticalAlign: "middle",
                              backgroundColor: "#6f42c1",
                              color: "#fff",
                            }}
                            title="Cette colonne est visible par les utilisateurs VO (531/631)"
                          >
                            531
                          </span>
                        )}
                    </>
                  )} */}
                  <span className="d-block">{columnsConfig[col].title}</span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {voColumns.map((col) => (
              <Cells
                key={col}
                type={col}
                toggle={() => {}}
                item={item}
                isOpen={true}
                onUpdateCell={(field, newValue) =>
                  actions.onUpdateCell(item, field, newValue)
                }
                onDeverrouillerFacturation={actions.onDeverrouillerFacturation}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FlotteLigneVO;
